// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__kjKyx","main":"NotFound_main__V11L2","title":"NotFound_title__xKiMo","desc":"NotFound_desc__XzYlT","link":"NotFound_link__wEnJ8"};